<template>
  <div>
    <checkbox
      v-for="(bucket, index) in visibleBuckets"
      :key="`${bucket.value}-${index}`"
      :bucket="bucket"
      :filterName="filterName"
      :class="{ 'bg-white-light': !isEven(index), 'px-3': !filter.collapsed }"
      :popup="filter.pop_up === 'mix' && bucket.data ? bucket.data.party_type : filter.pop_up"
      :isLocked="isLocked"
      :renderFlag="renderFlag"
      @selected="handleCheckbox">
    </checkbox>

    <a v-if="filter.buckets.length > maxBuckets" href="#" @click.prevent="toggleShowAll" class="t-sm position-relative px-3 pt-1 d-block">
      <span v-if="filter.show_all">Show less...</span>
      <span v-if="!filter.show_all && filter.typeahead">Show more...</span>
      <span v-if="!filter.show_all && !filter.typeahead">Show all ({{ filter.buckets.length }})</span>
      <i class="fa t-primary pt-1 pull-right" :class="{'fa-angle-down': !filter.show_all, 'fa-angle-up': filter.show_all }"></i>
    </a>
  </div>
</template>

<script>
import Checkbox from '@/components/search/Checkbox'

export default {
  name: 'bucketText',
  components: {
    Checkbox
  },
  props: {
    isFilterLoaded: {
      type: Boolean,
      default: false
    },
    isLocked: {
      type: Boolean,
      default: false
    },
    filterName: {
      type: String,
      required: true
    },
    filter: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    renderFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      maxBuckets: 10,
      buckets: []
    }
  },
  mounted () {
    if (this.isFilterLoaded) this.buckets = this.sortBuckets(this.filter.buckets)
  },
  watch: {
    isFilterLoaded (newVal, oldVal) {
      if (newVal !== oldVal && newVal) this.buckets = this.sortBuckets(this.filter.buckets)
    }
  },
  computed: {
    visibleBuckets () {
      if (this.filter.show_all) return this.buckets
      return this.buckets.slice(0, this.maxBuckets)
    }
  },
  methods: {
    sortBuckets (buckets) {
      // sort the checked + the ones with most count at the top
      if (this.filter.bucket_order) {
        buckets = buckets.slice().sort((a, b) => b.active - a.active || a.order - b.order)
      } else {
        buckets = buckets.slice().sort((a, b) => b.active - a.active || b.count - a.count)
      }

      return buckets
    },
    toggleShowAll () {
      const filter = Object.assign(this.filter, {})
      filter.show_all = !filter.show_all
      this.$emit('bucketShowAll', this.filterName, filter)
    },
    handleCheckbox (bucket, filterName) {
      bucket.active = !bucket.active
      this.$emit('bucketToggled', bucket, filterName)
    }
  }

}
</script>
